require('./bootstrap');

window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');

require('bootstrap');

require('confirm-submit');
require('select2');

require('./components/custom-file-input');
require('./components/form-conditional-fields');
require('./components/select2');
